module.exports = __webpack_public_path__ + "06579ba839f905a40f18baba21cca737.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/uacf-logo.png
// module id = 1855
// module chunks = 1